import { Waves } from "lucide-react";
import Link from "next/link";
import { footerSeoPages } from "@/generated/seo-metadata";
import styles from "./home-footer.module.css";

export function HomeFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.main}>
        <Link className={styles.brand} href="/" aria-label="Boardblend home">
          <span className="brand-mark" aria-hidden="true">
            <Waves />
          </span>
          <strong>Boardblend</strong>
        </Link>

        <div className={styles.columns}>
          <nav className={styles.links} aria-label="Product">
            <strong>Product</strong>
            <Link href="/#product">Overview</Link>
            <Link href="/#examples">Examples</Link>
            <Link href="/workshops">Workshops</Link>
            <Link href="/#pricing">Pricing</Link>
            <Link href="/#faq">FAQ</Link>
            <Link href="/sign-in">Sign in</Link>
          </nav>
          <nav className={styles.links} aria-label="Resources">
            <Link className={styles.columnHeading} href="/resources">
              Resources
            </Link>
            {footerSeoPages.map((page) => (
              <Link key={page.slug} href={`/resources/${page.slug}`}>
                {page.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>

      <div className={styles.bottom}>
        <span>© {new Date().getFullYear()} Boardblend</span>
        <nav className={styles.legal} aria-label="Legal">
          <Link href="/privacy">Privacy</Link>
          <Link href="/terms">Terms</Link>
        </nav>
      </div>
    </footer>
  );
}
